import React, { FC } from 'react';
import { Icon } from '@hz-design-system/web-ui';

const ListingImageNone: FC = () => {
  // TODO: find alterative for text-deprecated-placeholder
  return <Icon data-testid="noImage" name="camera_off" color="text-secondary" />;
};

export default ListingImageNone;
